import { alpha } from '@mui/material/styles'

export default function ToggleButton(theme) {
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          transition: 'all 0.2s ease-in-out',
          '&.Mui-disabled': {
            borderColor: theme.palette.divider,
            color: theme.palette.text.disabled,
          },
          '&.Mui-selected': {
            color: theme.palette.primary.contrastText,
            backgroundColor: alpha(theme.palette.primary.main, 1),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.dark, 0.9),
            },
          },
          '&:focus-visible': {
            outline: `2px solid ${theme.palette.secondary.dark}`,
            outlineOffset: 2,
          },
        },
      },
    },
  }
}
